module.exports = __webpack_public_path__ + "static/img/build1.b3521efc.png";